import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ActiveCondominioProvider } from "./context/ActiveCondominioContext";
import { FeaturesProvider } from "./context/FeaturesContext";
import { ToastProvider } from "./components/Toast/ToastProvider";
import Login from "./features/auth/Login";
import ExaustoresPage from "./features/exaustores/ExaustoresPage";
import ReservatoriosPage from "./features/reservatorios/ReservatoriosPage";
import ReservatorioAnalyticsPage from "./features/reservatorios/ReservatorioAnalyticsPage";
import BlocoAnalyticsPage from "./features/reservatorios/BlocoAnalyticsPage";
import PrivateRoute from "./utils/PrivateRoute";
import SessionTimeout from "./utils/SessionTimeout";
import CadastroUsuarios from "./features/cadastro/CadastroUsuarios";
import ConfigMenu from "./pages/ConfigMenu";
import AlertasConfig from "./features/alertas/AlertasConfig";
import FeatureConfig from "./pages/FeatureConfig";
import Home from "./pages/Home";

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
      <SessionTimeout>
        <ActiveCondominioProvider>
          <FeaturesProvider>
            <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/exaustao"
            element={
              <PrivateRoute featureName="exaustores">
                <ExaustoresPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/configuracoes/usuarios"
            element={
              <PrivateRoute adminOrSindico={true} featureName="usuarios">
                <CadastroUsuarios />
              </PrivateRoute>
            }
          />
          <Route
            path="/configuracoes"
            element={
              <PrivateRoute adminOrSindico={true}>
                <ConfigMenu />
              </PrivateRoute>
            }
          />
          <Route
            path="/configuracoes/alertas"
            element={
              <PrivateRoute adminOrSindico={true} featureName="alertas">
                <AlertasConfig />
              </PrivateRoute>
            }
          />
          <Route
            path="/configuracoes/features/:condominioId"
            element={
              <PrivateRoute adminOnly={true}>
                <FeatureConfig />
              </PrivateRoute>
            }
          />
          <Route
            path="/reservatorios"
            element={
              <PrivateRoute featureName="reservatorios">
                <ReservatoriosPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/reservatorios/bloco/analytics/:blocoId"
            element={
              <PrivateRoute featureName="reservatorios_analytics">
                <BlocoAnalyticsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/reservatorios/analytics/:id"
            element={
              <PrivateRoute featureName="reservatorios_analytics">
                <ReservatorioAnalyticsPage />
              </PrivateRoute>
            }
          />
          </Routes>
          </FeaturesProvider>
        </ActiveCondominioProvider>
      </SessionTimeout>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
